export const permissions = {
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  VIEW_USER: "VIEW_USER",
  VIEW_APPLICATION: "VIEW_APPLICATION",
  VIEW_DEPARTMENT: "VIEW_DEPARTMENT",
  ADD_USER: "ADD_USER",
  ADD_APPLICATION: "ADD_APPLICATION",
  ADD_DEPARTMENT: "ADD_DEPARTMENT",
  EDIT_USER: "EDIT_USER",
  EDIT_APPLICATION: "EDIT_APPLICATION",
  EDIT_DEPARTMENT: "EDIT_DEPARTMENT",
  DELETE_USER: "DELETE_USER",
  DELETE_APPLICATION: "DELETE_APPLICATION",
  DELETE_DEPARTMENT: "DELETE_DEPARTMENT",
  VIEW_ONBOARDINGMGMT: "VIEW_ONBOARDINGMGMT",
  REVIEW_ONBOARDINGMGMT: "REVIEW_ONBOARDINGMGMT",
  APPROVE_ONBOARDINGMGMT: "APPROVE_ONBOARDINGMGMT",
  VIEW_REQUESTMGMT: "VIEW_REQUESTMGMT",
  VIEW_MULTICLOUD: "VIEW_MULTICLOUD",
  ENABLE_INTEGRATION: "ENABLE_INTEGRATION",
  REMOVE_INTEGRATION: "REMOVE_INTEGRATION",
  MAP_INTEGRATION: "MAP_INTEGRATION",
  ADD_ADMINUSER: "ADD_ADMINUSER",
  VIEW_ADMINUSER: "VIEW_ADMINUSER",
  EDIT_ADMINUSER: "EDIT_ADMINUSER",
  DELETE_ADMINUSER: "DELETE_ADMINUSER",
  VIEW_MARKETPLACE: "VIEW_MARKETPLACE",
  VIEW_INTEGRATION: "VIEW_INTEGRATION",
  VIEW_PROJECT: "VIEW_PROJECT",
  VIEW_INVOICE: "VIEW_INVOICE",
  VIEW_SUBSCRIPTION: "VIEW_SUBSCRIPTION",
  VIEW_CONTRACT: "VIEW_CONTRACT",
  EDIT_PROJECT: "EDIT_PROJECT",
  ADD_CONTRACT: "ADD_CONTRACT",
  ADD_MULTICLOUD: "ADD_MULTICLOUD",
  EDIT_MULTICLOUD: "EDIT_MULTICLOUD",
  DELETE_MULTICLOUD: "DELETE_MULTICLOUD",
  DELETE_INVOICE: "DELETE_INVOICE",
  ADD_INVOICE: "ADD_INVOICE",
  ADD_WORKFLOW: "ADD_WORKFLOW",
  EDIT_WORKFLOW: "EDIT_WORKFLOW",
  VIEW_WORKFLOW: "VIEW_WORKFLOW",

};

export const Roles = {
  SUPER_ADMIN: "SUPER_ADMIN",
  REVIEWER: "REVIEWER",
  APPROVER: "APPROVER",
  CONTRIBUTOR: "CONTRIBUTOR",
  SUPPORT: "SUPPORT",
};

export const getPermissions = {
  [Roles.SUPER_ADMIN]: [
    permissions.VIEW_USER,
    permissions.VIEW_APPLICATION,
    permissions.VIEW_DEPARTMENT,
    permissions.VIEW_ONBOARDINGMGMT,
    permissions.REVIEW_ONBOARDINGMGMT,
    permissions.APPROVE_ONBOARDINGMGMT,
    permissions.ADD_ADMINUSER,
    permissions.VIEW_ADMINUSER,
    permissions.EDIT_ADMINUSER,
    permissions.DELETE_ADMINUSER,
    permissions.ADD_MULTICLOUD,
    permissions.EDIT_MULTICLOUD,
    permissions.DELETE_MULTICLOUD,
    permissions.VIEW_MULTICLOUD,
    permissions.ADD_INVOICE,
    permissions.DELETE_INVOICE,
    permissions.VIEW_PROJECT,
    permissions.VIEW_INTEGRATION,
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_INVOICE,
    permissions.VIEW_SUBSCRIPTION,
    permissions.VIEW_MARKETPLACE,
    permissions.VIEW_CONTRACT,
  ],
  [Roles.REVIEWER]: [
    permissions.VIEW_USER,
    permissions.VIEW_APPLICATION,
    permissions.VIEW_DEPARTMENT,
    permissions.VIEW_ONBOARDINGMGMT,
    permissions.REVIEW_ONBOARDINGMGMT,
    permissions.APPROVE_ONBOARDINGMGMT,
    permissions.VIEW_MULTICLOUD,
    permissions.VIEW_PROJECT,
    permissions.VIEW_INTEGRATION,
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_INVOICE,
    permissions.VIEW_SUBSCRIPTION,
    permissions.VIEW_MARKETPLACE,
    permissions.VIEW_CONTRACT,
  ],
  [Roles.APPROVER]: [
    permissions.VIEW_USER,
    permissions.VIEW_APPLICATION,
    permissions.VIEW_DEPARTMENT,
    permissions.VIEW_ONBOARDINGMGMT,
    permissions.REVIEW_ONBOARDINGMGMT,
    permissions.APPROVE_ONBOARDINGMGMT,
    permissions.VIEW_MULTICLOUD,
    permissions.VIEW_PROJECT,
    permissions.VIEW_INTEGRATION,
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_INVOICE,
    permissions.VIEW_SUBSCRIPTION,
    permissions.VIEW_MARKETPLACE,
    permissions.VIEW_CONTRACT,
  ],
  [Roles.CONTRIBUTOR]: [
    permissions.VIEW_USER,
    permissions.VIEW_APPLICATION,
    permissions.VIEW_DEPARTMENT,
    permissions.ADD_USER,
    permissions.ADD_APPLICATION,
    permissions.ADD_DEPARTMENT,
    permissions.EDIT_USER,
    permissions.EDIT_APPLICATION,
    permissions.EDIT_DEPARTMENT,
    permissions.DELETE_USER,
    permissions.DELETE_APPLICATION,
    permissions.DELETE_DEPARTMENT,
    permissions.VIEW_REQUESTMGMT,
    permissions.ENABLE_INTEGRATION,
    permissions.REMOVE_INTEGRATION,
    permissions.MAP_INTEGRATION,
    permissions.VIEW_MULTICLOUD,
    permissions.VIEW_INTEGRATION,
    permissions.VIEW_DASHBOARD,
    permissions.VIEW_INVOICE,
    permissions.VIEW_SUBSCRIPTION,
    permissions.VIEW_PROJECT,
    permissions.EDIT_PROJECT,
    permissions.VIEW_MARKETPLACE,
    permissions.VIEW_CONTRACT,
    permissions.ADD_CONTRACT
  ],
  [Roles.SUPPORT]: [
    permissions.ADD_WORKFLOW,
    permissions.EDIT_WORKFLOW, 
    permissions.VIEW_WORKFLOW, 
    permissions.VIEW_USER,
    permissions.VIEW_APPLICATION, 
    permissions.VIEW_DEPARTMENT, 
    permissions.VIEW_MULTICLOUD, 
    permissions.VIEW_PROJECT, 
    permissions.VIEW_INTEGRATION, 
    permissions.VIEW_DASHBOARD, 
    permissions.VIEW_INVOICE, 
    permissions.VIEW_SUBSCRIPTION, 
    permissions.VIEW_MARKETPLACE, 
    permissions.VIEW_CONTRACT, 
    permissions.ADD_INVOICE, 
    permissions.DELETE_INVOICE, 
  ]
  
};
